import { ViewConfig, Workbook } from "../../model/core/Workbook";
import { newDataset } from "datasheets/model/logic/new";
import { TabularDataConfig } from "datasheets/components/TabularDataView";

// /////////////////////////////
// // Register view
export const viewType = "spreadsheet";

type WithRequired<T, K extends keyof T> = T & { [P in K]-?: T[P] };

export interface SpreadsheetViewConfig
  extends ViewConfig,
    WithRequired<TabularDataConfig, "datasetId"> {}
export function generateSpreadsheetViewConfig(
  viewName: string,
  workbook: Workbook
): SpreadsheetViewConfig {
  const dataset = newDataset(viewName);
  workbook.data.datasets[dataset.id] = dataset;
  return {
    type: "spreadsheet",
    columnMapping: {},
    columnDisplayProperties: {},
    datasetId: dataset.id,
  };
}
